/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
// import Modal from 'react-modal';
import { Card, Modal } from 'react-bootstrap';
import { IAudioPlayerProps, AudioModal } from './AudioViewer';
import * as S from './styles';

export type IAudioModalProps = {
  showModal: boolean;
  closeModal?(): void;
  [key: string]: any;
} & IAudioPlayerProps;

export const AudioViewerModal = ({
  showModal,
  closeModal,
  ...rest
}: IAudioModalProps) => {
  return (
    <Modal
      show={showModal}
      style={S.ModalStyle}
      onHide={closeModal}
      fullscreen={true}
      scrollable={true}
      // appElement={typeof global?.window !== 'undefined' ? global?.window.document.body : undefined}
    >
      <Modal.Header closeButton>{rest?.title}</Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          <Card style={{ height: 'fit-content', display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
              }}
            >
              {' '}
              <AudioModal {...rest} closeModal={closeModal} />
            </div>
          </Card>
        </div>
      </Modal.Body>
    </Modal>
  );
};

AudioViewerModal.defaultProps = {
  showModal: false,
  closeModal: true,
};
